
    <ng-container *ngFor="let value of valueArray; let i = index">
      <br *ngIf="i !== 0"/>{{ value }}
    </ng-container>
  